import React from "react"
import classNames from "classnames"
import shallowCompare from "react-addons-shallow-compare"
import Relay from "react-relay"
import Icon from "./Icon"
import {
  getImageSrcFromResource,
  getPermalink,
  getImageType
} from "../../scripts/resource"
import { trackSocial } from "../../analyticsAndSocial"
import shareMessages from "../../messages/share"
import { injectIntl } from "react-intl"

class PinterestShare extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState)
  }

  render() {
    const { resource, pinterestColor, intl, relay: _1, ...props } = this.props

    const imageSrc =
      getImageSrcFromResource(
        resource,
        "medium",
        getImageType(resource),
        false
      ) || ""
    const titleEscaped = encodeURIComponent(resource.title)
    const permalink = getPermalink(resource)
    const encodedPermalink = encodeURIComponent(permalink)
    const href = `http://pinterest.com/pin/create/button/?url=${encodedPermalink}&description=${titleEscaped}&media=${imageSrc}`

    return (
      <a
        {...props}
        href={href}
        onClick={e => {
          e.preventDefault()
          window.open(
            href,
            "",
            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
          )
          trackSocial("Pinterest", permalink)
          return false
        }}
        target="_blank"
      >
        <Icon
          title={intl.formatMessage(shareMessages.sharePinterest)}
          icon="pinterest-circle"
          extraClasses={classNames({ "icon--color-pinterest": pinterestColor })}
        />
      </a>
    )
  }
}

export default Relay.createContainer(injectIntl(PinterestShare), {
  fragments: {
    resource: () => Relay.QL`
        fragment on Resource {
            id
            title
            files {
                type
                images {
                    medium { url width }
                }
            }
        }
        `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/PinterestShare.js